import { AxiosInstance } from "axios";
import type {
  SharePointColumns,
  SharePointList,
  SharePointSite,
} from "./SharePointSourceSettings.types";

export class SharePointSourceSettingsApi {
  constructor(private readonly client: AxiosInstance) {}

  async getSites(
    boardId: string,
    connectionId: string,
    searchTerm: string,
  ): Promise<SharePointSite[]> {
    const response = await this.client.get<SharePointSite[]>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/sharepoint/sites?searchTerm=${encodeURIComponent(searchTerm)}`,
    );

    return response.data;
  }

  async getLists(
    boardId: string,
    connectionId: string,
    siteId: string,
  ): Promise<SharePointList[]> {
    const response = await this.client.get<SharePointList[]>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/sharepoint/lists?siteId=${encodeURIComponent(siteId)}`,
    );

    return response.data;
  }

  async getColumns(
    boardId: string,
    connectionId: string,
    siteId: string,
    listId: string,
  ): Promise<SharePointColumns> {
    const response = await this.client.get<SharePointColumns>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/sharepoint/columns?siteId=${encodeURIComponent(siteId)}&listId=${encodeURIComponent(listId)}`,
    );

    return response.data;
  }
}
